'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
function $ct_Lmealorama_components_MuiComponents$MuiIcon__T__($thiz, ligature) {
  $thiz.hO = ligature;
  return $thiz;
}
export { $ct_Lmealorama_components_MuiComponents$MuiIcon__T__ as $ct_Lmealorama_components_MuiComponents$MuiIcon__T__ };
/** @constructor */
function $c_Lmealorama_components_MuiComponents$MuiIcon() {
  this.hO = null;
}
export { $c_Lmealorama_components_MuiComponents$MuiIcon as $c_Lmealorama_components_MuiComponents$MuiIcon };
$p = $c_Lmealorama_components_MuiComponents$MuiIcon.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_MuiComponents$MuiIcon;
/** @constructor */
function $h_Lmealorama_components_MuiComponents$MuiIcon() {
}
export { $h_Lmealorama_components_MuiComponents$MuiIcon as $h_Lmealorama_components_MuiComponents$MuiIcon };
$h_Lmealorama_components_MuiComponents$MuiIcon.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=mealorama.components.-Mui-Components$-Mui-Icon.js.map
